export default {"src":"/_next/static/media/clam.ab4e46af.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};